import React from 'react';
//import service from './dataService';

const FooterComponent = () => {
    return (
      <div>
        &nbsp;
      </div>);
	};

export default FooterComponent;